module.exports = __webpack_public_path__ + "static/ss5.3910c761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/laminardata/ss/ss5.png
// module id = 1168
// module chunks = 112875127094159